import { render, staticRenderFns } from "./PanelOne.vue?vue&type=template&id=35f23b9b&scoped=true&"
import script from "./PanelOne.vue?vue&type=script&lang=js&"
export * from "./PanelOne.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f23b9b",
  null
  
)

export default component.exports